// extracted by mini-css-extract-plugin
module.exports = {"trendingItem":"style_trendingItem__TbxoZ","timeSpan":"style_timeSpan__Q4r2l","desc":"style_desc__sFKBM","timestamp":"style_timestamp__s4It9"};